import { render, staticRenderFns } from "./TableThresholdEdit.vue?vue&type=template&id=21e110d5&scoped=true"
import script from "./TableThresholdEdit.vue?vue&type=script&lang=js"
export * from "./TableThresholdEdit.vue?vue&type=script&lang=js"
import style0 from "./TableThresholdEdit.vue?vue&type=style&index=0&id=21e110d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e110d5",
  null
  
)

export default component.exports